module.exports = __webpack_public_path__ + "img/bg_wall.49f9e420.png";